/**
 * EpisodesSlider.js — 4-up swipeable slider with a 25% peek of the next slide, no arrows or dots
 */
import Swiper from 'swiper';

export default class EpisodesSlider {
  constructor(selector = '.episodes-slider') {
    this.el = document.querySelector(selector);
    if (!this.el) return;

    this.swiper = new Swiper(this.el, {
      slidesPerView: 1.25,
      spaceBetween: 16,
      breakpoints: {
        640:  { slidesPerView: 2.25, spaceBetween: 20 },
        1024: { slidesPerView: 3.25, spaceBetween: 20 },
        1280: { slidesPerView: 4.25, spaceBetween: 20 },
      },
    });
  }
}
